// extracted by mini-css-extract-plugin
export default {"zoomModal":"_3-z"};